// BookTickets/stages/PaymentProcess/PaymentForm.tsx
'use client'

import Image from 'next/image'
import cn from 'classnames'
import { useTranslations } from 'next-intl'

import styles from './index.module.scss'
import './external-form.scss'

import AcceptIcons from './accept-icons.png'

type PaymentFormProps = {
  /**
   * Where the hosted payment widget should post back to.
   * Usually includes cartId + paymentMethod in query string.
   */
  action: string
}

export default function PaymentForm({ action }: PaymentFormProps) {
  const t = useTranslations('booking')

  return (
    <div className={cn(styles.paymentFormWrapper)}>
      <div className={cn(styles.header)}>
        <h3 className={cn(styles.cardTitle)}>{t('ticket.payment.cardDetails')}</h3>

        <div className={cn(styles.icons)}>
          <span>{t('ticket.payment.accept')}:</span>
          <Image
            src={AcceptIcons}
            alt={t('ticket.payment.accept', { default: 'Accepted cards' })}
          />
        </div>
      </div>

      {/* Payment widget mounts into this form */}
      <form action={action} className="paymentWidgets" data-brands="VISA MASTER AMEX" />
    </div>
  )
}
